import React, { createContext, useContext, useState } from 'react';

const UserContext = createContext();

//used in v2 only
export function UserProvider({ children }) {
    const [clientId] = useState(process.env.REACT_APP_RELAY_CLIENT_ID || '');
    const [jwt] = useState(process.env.REACT_APP_RELAY_JWT || '');

    return (
        <UserContext.Provider value={{ clientId, jwt }}>
            {children}
        </UserContext.Provider>
    );
}

export function useUser() {
    const context = useContext(UserContext);
    if (!context) {
        throw new Error('useUser must be used within a UserProvider');
    }
    return context;
}
